import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterTemplateImagesList_template} from "../components/templates/newsletterTemplateImagesList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class newsletter_template_images extends vnModule_knockoutJS {

    protected XHRHdl!: XMLHttpRequestHandler;
    protected newsletterTemplateImagesList!: newsletterTemplateImagesList_template;
    protected pagination!: pagination_template;

    buildContent(): Array<Element> {
        this.newsletterTemplateImagesList = new newsletterTemplateImagesList_template("newsletterTemplateImagesList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader!.loadedModule;
        (<header>loadedModule).setHeaderTitle("Newsletter Header Images");
        return [this.newsletterTemplateImagesList.build()];
    }

    protected getModuleName(): string {

        return "newsletter_template_images";
    }

    fillPage() {

        this.getImagesListData();
    }

    protected getImagesListData() {

        this.loadingIn(this.newsletterTemplateImagesList.builtTemplate.children.namedItem("list-results")!);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.newsletterTemplateImagesList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/newsletter/templates/images/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetImagesListDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetImagesListDataReturn(req: any, obj: any) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let images = responseParsed.data;

                obj.viewModel.newsletterTemplateImagesList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.newsletterTemplateImagesList.setResultInfo(totalCount, totalPage, execTime)
                obj.newsletterTemplateImagesList.setImages(images)

            });
            obj.loadingOut(obj.newsletterTemplateImagesList.builtTemplate.children.namedItem("list-results")!);
        }
    }

    protected imagesListReorder() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.getImagesListData()
    }

    protected paginationOnPageClick() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getImagesListData();
    }

    protected filterSimpleOnChange(){

        this.viewModel.newsletterTemplateImagesList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.newsletterTemplateImagesList.builtTemplate.children.namedItem("list-results")!);

        let imagesReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/images/get/';
        let imagesReq_params: Array<Array<string>> = [];
        imagesReq_params.push(["data", ko.toJSON(this.newsletterTemplateImagesList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(imagesReq_url, imagesReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req: any, obj: any){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterTemplateImagesList.setImages(responseParsed.data);

                let execTime = Math.round((new Date().getTime() - obj.XHRHdl.requestStartTime)/1000*100)/100;
                obj.newsletterTemplateImagesList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

                obj.viewModel.newsletterTemplateImagesList.pagination.itemCount(responseParsed.totalCount);
            });
            obj.loadingOut(obj.newsletterTemplateImagesList.builtTemplate.children.namedItem("list-results")!);
        }
    }

    protected cancel() {

        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + "/newsletter/templates/")
    }

    protected add() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/images/add/')
    }

    protected edit(id: any) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/images/edit/' + id + '/')
    }

    protected delete(data: any) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url = "/api/brand/" + idBrand + "/newsletter/templates/images/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.newsletterTemplateImagesList.builtTemplate.children.namedItem("list-results")!);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req: any, obj: any) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Header Image " + "<strong>" + data.name + "</strong>" + " was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getImagesListData()
                })

                obj.loadingOut(obj.newsletterTemplateImagesList.builtTemplate.children.namedItem("list-results")!);
            }
        });
        XHRHdl.execute();
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_template_images.ts